import React from "react";
import {useTranslation} from "react-i18next";

import { CheckCircleOutline as CheckCircleOutlineIcon } from '@vedmarket/ui-kit';
import Notification, {NOTIFICATION_TYPE} from "../../../../../../../../../../../../common/notification";

type Props = {
    documentName: string
}

const CertificationNoNeeded = ({documentName} : Props) => {

  const { t } = useTranslation()

  return <Notification
    sx={{ marginTop: 3 }}
    type={NOTIFICATION_TYPE.SUCCESS}
    icon={<CheckCircleOutlineIcon/>}
    noCloseButton
    title={`${t('dictionaries__text__certification__for')} ${documentName} ${t('dictionaries__text__certification__certificationIsNotRequired')}`}
  />
}

export default CertificationNoNeeded
